import React from 'react';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import { styled } from '@mui/material/styles';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import clsx from 'clsx';

export interface SortOption {
  label: string;
  value: string;
}

interface SortDropdownProps {
  options: SortOption[];
  value: string;
  onChange: (value: string) => void;
  className?: string;
}

const CustomSelect = styled(Select)(({ theme }) => ({
  background: '#fff',
  borderRadius: 8,
  fontWeight: 600,
  fontSize: 14,
  boxShadow: 'none',
  border: '1px solid #D0D5DD',
  '& .MuiSelect-select': {
    padding: '10px 16px',
    display: 'flex',
    alignItems: 'center',
    fontWeight: 600,
    fontSize: 14,
    color: '#1C1B1F',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
}));

const CustomMenuItem = styled(MenuItem)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 600,
  color: '#23272F',
  padding: '10px 24px 10px 16px',
  borderRadius: 8,
  backgroundColor: '#fff',
  '&.Mui-selected, &.Mui-selected:hover': {
    backgroundColor: '#fff !important',
    fontWeight: 700,
  },
  '&:hover': {
    backgroundColor: '#fff',
  },
  display: 'flex',
  alignItems: 'center',
}));

const SortDropdown: React.FC<SortDropdownProps> = ({ options, value, onChange, className }) => {
  return (
    <CustomSelect
      value={value}
      onChange={(e) => onChange(e.target.value as string)}
      IconComponent={KeyboardArrowDownIcon}
      className={className}
      MenuProps={{
        PaperProps: {
          className: 'border border-stone-200 mt-2',
          style: {
            boxShadow: 'none',
            borderRadius: '8px',
            padding: 0,
          },
        },
      }}
      renderValue={() => {
        const selected = options.find((opt) => opt.value === value);
        return (
          <span className="text-xs font-semibold text-stone-900 flex items-center">
            {selected?.label || 'Sort By'}
          </span>
        );
      }}
    >
      {options.map((option) => (
        <CustomMenuItem key={option.value} value={option.value} selected={value === option.value}>
          <ListItemIcon className="min-w-0 bg-white">
            {value === option.value ? (
              <span className=" w-5 h-5 rounded-full border-2 border-gray-700 flex items-center justify-center bg-white">
                <span className="w-2.5 h-2.5 rounded-full bg-gray-700 block"></span>
              </span>
            ) : (
              <span className="w-5 h-5 rounded-full border-2 border-gray-400 flex items-center justify-center bg-white"></span>
            )}
          </ListItemIcon>
          <span className="text-gray-700 font-medium">{option.label}</span>
        </CustomMenuItem>
      ))}
    </CustomSelect>
  );
};

export default SortDropdown;
